import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth-gurd.guard';
import { GrameenphoneDocsComponent } from './pages/config/grameenphone-docs/grameenphone-docs.component';
import { DocumentationComponent } from './pages/config/banglalink/documentation/documentation.component';
import { RobiDocumentationComponent } from './pages/config/robi/robi-documentation/robi-documentation.component';
import { NgDocumentationComponent } from './pages/config/nagad/ng-documentation/ng-documentation.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/robi/robi.module').then((m) => m.RobiModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'robi',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/robi/robi.module').then((m) => m.RobiModule),
  },
  {
    path: 'banglalink',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/banglalink/banglalink.module').then(
        (m) => m.BanglalinkModule
      ),
  },
  {
    path: 'grameenphone',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/grameenphone/grameenphone.module').then(
        (m) => m.GrameenphoneModule
      ),
  },
  {
    path: 'sync-vendor',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/sync-vendor/sync-vendor.module').then(
        (m) => m.SyncVendorModule
      ),
  },
  {
    path: 'config',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/config/config.module').then((m) => m.ConfigModule),
  },
  {
    path: 'ads-notify-vendor',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/ads-notify-vendor/ads-notify.module').then(
        (m) => m.AdsNotifyModule
      ),
  },
  {
    path: 'public/config/grameenphone/docs/:id',
    component: GrameenphoneDocsComponent,
  },
  {
    path: 'public/config/banglalink/docs/:id',
    component: DocumentationComponent,
  },
  {
    path: 'public/config/robi/docs/:id',
    component: RobiDocumentationComponent,
  },
  {
    path: 'public/config/nagad/docs/:id',
    component: NgDocumentationComponent,
  },
  {
    path: 'others',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/others/others.module').then((m) => m.OthersModule),
  },
  {
    path: 'charging-notify',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/charging-notify/charging-notify.module').then(
        (m) => m.ChargingNotifyModule
      ),
  },
  {
    path: 'charging',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/charging/charging.module').then(
        (m) => m.ChargingModule
      ),
  },
  {
    path : 'reporting',
    canActivate : [AuthGuard],
    loadChildren : () => import('./pages/reporting/reporting.module').then((m) => m.ReportingModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
